module.exports = __webpack_public_path__ + "img/preventionInfKt.69b5a775.jpg";